import { Result } from "core/utils";
import { Tracking } from "core/tracking";
export function trackPageResult(result) {
    if (Result.isFail(result))
        Tracking.trackPageError(result.value);
    if (Result.isSuccess(result)) {
        trackPagePayload(result.value);
    }
}
function trackPagePayload(pagePayload) {
    if (pagePayload.kind === "Matched") {
        Tracking.trackPage(pagePayload.page);
    }
}
